import type { StripeBalance } from '../types/api'

export const useStripeBalance = () => useState<{
  loading: boolean
  balance: null | StripeBalance
}>('stripe-balance', () => ({ loading: false, balance: null }))
